import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAccessDeniedNavigate } from 'src/utils/accessDenied';

/**
 * Wires soft navigation for Access Denied (used by route-level guards).
 *
 * Does NOT register a global axios 403 → /403 redirect.
 * Background API 403s are handled by callers; restricted pages use PermissionGuard.
 */
export default function Axios403Handler() {
  const navigate = useNavigate();

  useEffect(() => {
    setAccessDeniedNavigate(navigate);

    return () => {
      setAccessDeniedNavigate(null);
    };
  }, [navigate]);

  return null;
}
